export const htmlDecode = (input: string) =>
  new DOMParser().parseFromString(input, 'text/html').documentElement
    .textContent;
